<template>
  <div class="font-nunito text-base text-black dark:text-white dark:bg-slate-900 mt-[74px]">
    <nav-bar-component />
    <contact-hero-component />
    <!-- <contact-mail-component /> -->
    <contact-map-component />
    <footer-component />
  </div>
</template>

<script>
import ContactHeroComponent from '@/components/ContactHeroComponent.vue'
import NavBarComponent from '@/components/NavBarComponent.vue'
import ContactMailComponent from '@/components/ContactMailComponent.vue'
import ContactMapComponent from '@/components/ContactMapComponent.vue'
import FooterComponent from '@/components/footerComponent.vue'
export default {
  components: { ContactHeroComponent, NavBarComponent, ContactMailComponent, ContactMapComponent, FooterComponent },
  data() {
    return {

      currentDate: new Date().getFullYear(),
      contact: {
        tel: '+229 567 777 79',
        email: 'contact@bsd-solution.com',
      },
      contactMail: [
        { nom: '' },
        { email: '' },
        { objet: '' },
        { commentaire: '' },
      ],
    }
  }

}
</script>

<style></style>